import React from "react";
import { Row, Col } from "reactstrap";
import "flag-icons/css/flag-icons.min.css";
import countriesByContinent from "../../../utils/countries";

export default function ShippingRates({ selectedCountries }) {
  let countrySettings = Object.entries(countriesByContinent).flatMap(([continent, countries]) =>
    countries
      .filter((country) => selectedCountries.includes(country.code))
      .map((country) => ({
        ...country,
        continent, // add continent back
      }))
  ) || [];

  return (
    <Row className="mt-3 mb-2">
      <Col sm="12">
        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
          {countrySettings?.map((country) => (
            <div
              key={country.code}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                backgroundColor: "rgb(198 196 196)",
                padding: "2px 10px",
                borderRadius: 7,
                color: "black",
              }}
            >
              {/* flag */}
              <span className={`fi fi-${country.code.toLowerCase()}`} style={{ width: "20px", height: "15px" }}></span>

              {/* country name */}
              <span style={{ fontSize: "0.9rem" }}>{country.name}</span>
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
}
